"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCrossReference = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
const product_model_1 = require("./product.model");
class ProductCrossReference extends common_1.MongoDocument {
}
exports.ProductCrossReference = ProductCrossReference;
//# sourceMappingURL=product-cross-reference.model.js.map